/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/edit'
export default icon
